<template>

<div id="" class="leftmenu artist-single" v-if="artist && !is_fetching_content">


    <router-link :to="backLink" class="lm-link lm-backbtn trigger-nav-back">
        Back        
    </router-link>

    

    <h1 class="lm-h1">
        <span class="styled">
            {{artist.first_name}}
        </span>
        <span class="straight">
            {{artist.last_name}}
        </span>
    </h1>

    <template v-if="book_visible('portfolio')">
        <router-link :to="'/artist/'+artist.slug" class="lm-link" :class="{current:(book=='portfolio')}">
            Portfolio
        </router-link>
        <br>
    </template>

    <template v-if="book_visible('runway')">
        <router-link :to="'/artist/'+artist.slug+'/runway'" class="lm-link" :class="{current:(book=='runway')}">
            Runway
        </router-link>
        <br>
    </template>

    <template v-if="book_visible('polaroids')">
        <router-link :to="'/artist/'+artist.slug+'/polaroids'" class="lm-link" :class="{current:(book=='polaroids')}">
            Polaroids
        </router-link>
        <br>
    </template>

    <template v-if="book_visible('portfolio')">
        <router-link :to="'/artist/'+artist.slug+'/full-book'" class="lm-link" :class="{current:(book=='full-book')}">
            Full book
        </router-link>
        <br><br>        
    </template>

    <br>


    <template v-if="artist.instagram_link">
        <a :href="artist.instagram_link" target="_blank" class="lm-link">
            Instagram
        </a>
        <br><br>
    </template>

    <template v-if="artist.modelsdotcom_link">
        <a :href="artist.modelsdotcom_link" class="lm-link" target="_blank">
            artists.com
        </a>
        <br><br>
    </template>


    <div class="optionsbtn" :class="{open:showOptions}" @mouseleave="showOptions=false">
        <div class="tbtn" @click="toggleOptions()">Options</div>
        <div class="sbtns">
            <a class="sbtn" :href="base_url+'artists/'+artist.slug+'/download/setcard'">Download setcard</a>
            <a class="sbtn" :href="base_url+'artists/'+artist.slug+'/download/polaroids'">Download polaroids</a>
            <a class="sbtn" :href="base_url+'artists/'+artist.slug+'/download/full_book'">Download full book</a>
        </div>
    </div>

    <template v-if="loggedin_user">

        <br><br>

        <a class="lm-link lvl1" :href="'https://scoopmodels.com/admin'">Admin</a><br>
        <a class="lm-link lvl1" :href="'https://scoopmodels.com/admin/artist/'+artist.id">Edit {{artist.first_name}}</a><br>

        <div class="lm-link lvl1 trigger-layout-block-edit-mode-btn" v-if="!editing_blocks && this.book != 'full-book'" @click="editLayout()">
            Edit layout
        </div>

    </template>

</div>

</template>
<script>
import mixins from '.././mixins.js'


export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		
	},

	data(){ return {                            
        showOptions: false,
	}},


	computed: {

		book(){
			var book = this.route.params.book
			if( !book ) book = 'portfolio'
			return book
        },

        artist(){ return this.$store.state.loaded_artist },

        lastartistsList(){
            var routes = this.$store.state.route.previous
            if( !routes.length ) return

            for( var i = 0; i < routes.length; i++ ) {
                var route = routes[i]
                if( route.meta && route.meta.tags && route.meta.tags._artists_list ) {
                    return route                    
                }
            }
        },

        backLink(){

            if( this.lastartistsList ) {
                return this.lastartistsList.path
            }

            return '/'            

        },

	},

	methods: {

        toggleOptions(){ this.showOptions = !this.showOptions },
        
        editLayout(){
            this.$store.commit('set_editing_blocks', true)
        },

        book_visible(book_slug){
            if( this.loggedin_user ) return true
            if( !this.artist.books ) return false
            if( !this.artist.books[book_slug] ) return false
            return true
        },

	},

	created(){
		
	},

}
</script>



// WEBPACK FOOTER //
// src/views/LeftMenuArtist.vue